import React from "react";
import { Row, Col, Button } from "reactstrap";

export default function SinglePurchaseItem(props)
{
    return <Col xs="12" md="4" className="mb-4 text-center">
    <h3 className="mb-4">{props.caption}</h3>
    <Row>
      <Col
        xs="12"
        className="mb-4 text-center justify-content-center">
        <img
          src={props.icon}
          alt={props.iconAlt}
          className="landing-page-icons"
        />
      </Col>
      <Col
        xs="12"
        className="mb-4 text-center justify-content-center">
        <h5>
          {props.text}
        </h5>
      </Col>
      <Col
        xs="12"
        className="mb-5 buy-now-button text-center justify-content-center">
        <a
          href={props.url}>
          <Button color="primary" className="d-none d-md-block">
          {props.buttonText}
            </Button>
        </a>
        <a
          href={props.url}>
          <Button color="primary" block className="d-md-none">
            {props.buttonText}
            </Button>
        </a>
      </Col>
    </Row>
  </Col>;
}